import { Component, OnInit } from '@angular/core';
import { NavItem } from '@assetaccountant/core/models/nav-item';
import { AppNavigationService } from '@assetaccountant/core/services/app-navigation.service';

@Component({
  selector: 'app-sub-navigation',
  templateUrl: './sub-navigation.component.html',
  styleUrls: ['./sub-navigation.component.scss'],
  standalone: false,
})
export class SubNavigationComponent implements OnInit {
  currentNav: NavItem | null;

  subNav: NavItem[] | undefined;

  constructor(private appNavigationService: AppNavigationService) {}

  ngOnInit() {
    this.appNavigationService.subNavigation.subscribe(subNav => {
      this.subNav = subNav;
      if (subNav) {
        this.currentNav = this.appNavigationService.getCurrentNavigationItem(subNav);
      }
    });
  }
}
